function initQuantityInput(container, callback) {
  const controls = container.querySelectorAll('[data-controls]');
  const label = container.querySelector('[data-value]');
  const min = container.dataset.hasOwnProperty('min') ? parseInt(container.dataset.min) : false;
  const max = container.dataset.hasOwnProperty('max') ? parseInt(container.dataset.max) : false;
  controls.forEach((trigger) => {
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      const value = parseInt(container.dataset.quantity);
      const result = getInputResult(trigger.dataset.controls, value, min, max);
      label.dataset.value = result;
      label.textContent = result;
      container.dataset.quantity = result;
      callback(container, result);
    });
  });
}

function getInputResult(operation, value, min = 0, max = false) {
  const result = operation === 'add' ? value + 1 : value - 1;
  if (min !== false && result < min) return min;
  if (max !== false && result > max) return max;
  return result;
}
